<template>
  <div class="bg-white">
    <Cover />
    <div class="container lg:px-12 md:px-12 px-4 mb-16">
      <Content />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Cover from "./components/CoverPage.vue";
import Content from "./components/Content.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    Cover,
    Content,
    DownloadApp,
    Footer,
  },
};
</script>
